import { render, staticRenderFns } from "./setUserGroupAcls.vue?vue&type=template&id=7386ada9"
import script from "./setUserGroupAcls.vue?vue&type=script&lang=js"
export * from "./setUserGroupAcls.vue?vue&type=script&lang=js"
import style0 from "./setUserGroupAcls.vue?vue&type=style&index=0&id=7386ada9&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports